<template>
    <div class="activityDetail-block">
        <AddCart/>
        <navigation-bar Close/>
        <div class="main">
            <div class="activity-block">
                <!-- 活動資訊頁內層 -->
                <nav class="sub-tab top-button-show">
                    <a :class="{active: activeTab === 'intro'}" @click="typeChanged('intro')">介紹</a>
                    <a :class="{active: activeTab === 'brand'}" @click="typeChanged('brand')" v-show="shoppingActInfo.mixStoreListCount>0">店家</a>
                    <a :class="{active: activeTab === 'map'}" @click="typeChanged('map')" v-show="isShowMapTab(shoppingActMap)">地圖</a>
                </nav>
                <IntroActivity v-show="activeTab==='intro'" :actInfo="shoppingActInfo"/>
                <Brand v-show="activeTab==='brand'" :actInfo="shoppingActInfo" :isOnActivity="msg"/>
                <Map v-show="activeTab==='map'" :outerActMap="shoppingActMap"/>
            </div>
        </div>
    </div>

</template>

<script>
    import Brand from './components/BrandActivity';
    import Map from './components/MapActivity';
    import IntroActivity from "./components/IntroActivity";
    import AddCart from '@/views/product/components/AddCart.vue'
    export default {
        name: "MarketplaceActivity",
        components: {
            IntroActivity,
            Brand,
            Map,
            AddCart,
        },
        props: {
        },
        watch: {
            //監聽，等到資料有變動再開始動作
            // outerActInfo: function() {
            //     let self = this;
            //     if (this.outerActInfo !== undefined) {
            //         self.shoppingActInfo = self.outerActInfo;
            //
            //         //取得地圖
            //         if (self.$public.notNull(self.shoppingActInfo)) {
            //             self.getShoppingActMap()
            //                 .catch((error) => {
            //                     console.log(`loading error: ${error}`);
            //                 });
            //         }
            //     }
            // },
        },
        data() {
            return {
                //分頁
                activeTab:'intro',
                shopAreaId: Number(this.$store.state.shopAreaInfo.id),   //商圈 id
                shoppingActInfo: {},            //商圈活動資訊
                shoppingActMap: {},             //商圈活動地圖
                msg: '',
                id: 0,
                code: this.$route.query.code ?? '',

                shopStoreList: [],
            }
        },
        created() {

            try {
                if (this.code !== '') {
                    this.getShoppingActInfo().then(() => {
                        this.getShoppingActMap().then(() => {

                        }).catch((error) => {
                            console.log(`loading error: ${error}`);
                        });
                    })
                }
            } catch (e) {
                this.$router.go(-1);
            }


        },
        mounted() {
            // this.typeChanged('brand');

        },
        methods: {

            /** 取得商圈活動資訊 */
            getShoppingActInfo: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈目前活動資訊
                    self.$http.fetch`GetShoppingActInfo${{
                        // activityId: self.id,
                        code: self.code,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.shoppingActInfo = json.data;
                            //完畢
                            resolve();

                        } else {
                            //完畢
                            resolve();
                        }
                    }}`;
                });
            },

            /**  */
            typeChanged(activeTab) {
                if (this.$public.notNull(this.$store.state.shopAreaInfo.id)) {
                    if (this.$public.notNull(this.$route.query.activeTab) && (this.$route.query.activeTab !== activeTab)) {
                        this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab, shopAreaId: this.shopAreaId }});
                    }
                } else {
                    // this.$router.push({ name: this.$route.name, query: { activeTab: activeTab }});
                    this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab }});
                }

                if (activeTab === 'brand') {
                    this.msg = 'aa';
                }
                // this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab }});
                this.activeTab = activeTab
                this.$emit("activeTab", this.activeTab)
            },

            /** 取得商圈地圖 */
            getShoppingActMap: function () {
                // let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //商圈活動地圖
                    self.$http.fetch`GetShoppingActMap${{
                        activityId: self.shoppingActInfo.id,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.shoppingActMap = json.data;
                            //完畢
                            resolve();

                        } else {
                            reject("Can't read activity map !");
                        }
                    }}`;
                });
            },

            /** 是否顯示地圖頁籤 */
            isShowMapTab: function(item) {
                // return true;
                return (this.$public.notNull(item) &&
                    (this.$public.notNull(item.mapImageUrl) && item.mapImageUrl !== '') ||
                    (this.$public.notNull(item.geographicNote) && item.geographicNote !== '') ||
                    (this.$public.notNull(item.googleMapUrl) && item.googleMapUrl !== '')) ;
            },

            checkShopStoreList: function (item) {
                this.shopStoreList = item;
            },
        }
    }
</script>

<style lang="less" scoped src="../../less/complex.less"/>
